import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'appIsArray',
  standalone: true,
})
export class IsArrayPipe implements PipeTransform {
  transform(value: any): Array<any> {
    return Array.isArray(value) ? value : [value];
  }
}
